import {Component} from '@angular/core';

@Component({
    templateUrl: './password-reset-init-success.component.html',
    styleUrls: [ './password-reset-init-success.component.scss' ]
})
export class PasswordResetInitSuccessComponent {

}
